<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-info mr-5"></i>{{'frequently_asked_questions' | translate}}</h2>
      </div>
      <div class="box-body">
        <div class="col-md-12">
          <div id="accordion-test-2" class="panel-group joined">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-1" data-parent="#accordion-test-2" data-toggle="collapse">Wie kann ich mich einloggen?</a>
                </h4>
              </div>
              <div id="collapse-1" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sie können sich mit den entsprechenden Qualibet-Zugangsdaten, die wir Ihnen vor Aktivierung zukommen lassen haben, einloggen. Sollte es zu Problemen während der Anmeldung kommen, überprüfen Sie bitte zunächst die korrekte Schreibweise Ihrer Zugangsdaten. Haben Sie die vermeintlichen Zugangsdaten korrekt eingegeben und der Zugang wird Ihnen trotz wiederholter Eingabe verwehrt, setzen Sie sich bitte mit unserer Service-Abteilung in Verbindung.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-4" data-parent="#accordion-test-2" data-toggle="collapse">Wie verwalte ich eingehende Bestellungen?</a>
                </h4>
              </div>
              <div id="collapse-4" class="panel-collapse collapse in">
                <div class="panel-body">
                  In Ihrem Login- Bereich auf Qualibet können Sie Ihre Bestellungen bequem und zentral verwalten, bearbeiten und abwickeln. Sie haben selbstverständlich auch die Möglichkeit, diverse Statistiken und Monatsreports abzurufen.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-5" data-parent="#accordion-test-2" data-toggle="collapse">Wie erfahre ich vom Eingang einer Bestellung?</a>
                </h4>
              </div>
              <div id="collapse-5" class="panel-collapse collapse in">
                <div class="panel-body">
                  Der Eingang einer Bestellung wird Ihnen automatisch an Ihre hinterlegte E-Mail Adresse gesendet. Eine entsprechende Annahme der Bestellung und die Einsicht der jeweiligen Detailinformationen erfolgt im Bestell-Bereich auf Qualibet.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-6" data-parent="#accordion-test-2" data-toggle="collapse">In welchem Zeitraum muss ich eine Bestellung annehmen, bearbeiten und versenden?</a>
                </h4>
              </div>
              <div id="collapse-6" class="panel-collapse collapse in">
                <div class="panel-body">
                  Je schneller Sie eine Bestellung annehmen und versenden, desto größer ist die Zufriedenheit des Kunden. Generell müssen Bestellungen innerhalb von 48 Std. nach Auftragseingang bearbeitet sein. Um eine Bestellung anzunehmen klicken Sie auf den Button "Versandpapiere erstellen". Bitte prüfen Sie vor dieser Aktion sorgfältig ob der Artikel tatsächlich verfügbar ist, da im Anschluss keine Stornierung mehr möglich ist.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-7" data-parent="#accordion-test-2" data-toggle="collapse"
                  >Ein Artikel wurde bestellt und dieser ist leider nicht mehr lieferbar. Was muss ich in diesem Fall tun?</a>
                </h4>
              </div>
              <div id="collapse-7" class="panel-collapse collapse in">
                <div class="panel-body">
                  In so einem Fall stornieren Sie bitte den entsprechenden Artikel <strong>umgehend nach Auftragseingang</strong> in der Bestellung. Dafür klicken Sie in der Bestellung auf den Button "Optionen" und wählen die Aktion "Stornieren" aus. Dies sollte jedoch zu den Ausnahmen gehören, denn letzten Endes wird damit nicht nur dem Image der jeweiligen Plattform geschadet, sondern auch Ihrem Unternehmen. Bitte beachten Sie daher, dass jede Stornierung in unsere interne schuhe.de-Händlerbewertung mit einfließt.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-8" data-parent="#accordion-test-2" data-toggle="collapse">Welche Funktion hat der Bestellstatus "offen"?</a>
                </h4>
              </div>
              <div id="collapse-8" class="panel-collapse collapse in">
                <div class="panel-body">
                  Der Bestellstatus "offen" zeigt Ihnen an, dass die Bestellung von Ihnen bearbeitet und versendet werden kann.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-9" data-parent="#accordion-test-2" data-toggle="collapse">Welche Funktion hat der Bestellstatus "reserviert"?</a>
                </h4>
              </div>
              <div id="collapse-9" class="panel-collapse collapse in">
                <div class="panel-body">
                  Der Bestellstatus "reserviert" zeigt Ihnen an, dass der Artikel der Bestellung bitte von Ihnen reserviert werden soll. Es handelt sich hierbei um eine Bestellung die mit der Zahlungsart Vorkasse vorgenommen wurde und der Zahlungseingang hierfür noch nicht eingegangen ist. Sobald die Zahlung zu der Bestellung eingegangen ist, erhält die Bestellung den Status "offen" und kann von Ihnen bearbeitet werden. Sollte kein Zahlungseingang eintreffen, wird die Bestellung automatisch nach einigen Tagen storniert.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-10" data-parent="#accordion-test-2" data-toggle="collapse">
                    Welche Funktion hat der Bestellstatus "storniert"?
                  </a>
                </h4>
              </div>
              <div id="collapse-10" class="panel-collapse collapse in">
                <div class="panel-body">
                  Mit dem Status "storniert" können Sie einzelne Artikel aus der Bestellung stornieren, insofern die Artikel bei Ihnen nicht mehr verfügbar sind. Dafür klicken Sie in der Bestellung auf den Button "Optionen" und wählen die Aktion "Stornieren" aus. Dies sollte jedoch zu den Ausnahmen gehören, denn letzten Endes wird damit nicht nur dem Image der jeweiligen Plattform geschadet, sondern auch Ihrem Unternehmen. Bitte beachten Sie daher, dass jede Stornierung in unsere interne schuhe.de-Händlerbewertung mit einfließt.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-11" data-parent="#accordion-test-2" data-toggle="collapse">Welche Funktion hat der Bestellstatus "versendet"?</a>
                </h4>
              </div>
              <div id="collapse-11" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sobald Sie die Aktion "Versandpapiere erstellen" ausgewählt haben, erhält der Kunde eine automatische E-Mail über die Versendung der jeweiligen Artikel mit dem dazugehörigen Tracking Code. Somit werden Kunden bereits frühzeitig über den ungefähren Liefertermin informiert und können Ihre Sendung online mit dem Tracking Code nachverfolgen.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-12" data-parent="#accordion-test-2" data-toggle="collapse">Wo finde ich die Lieferadresse?</a>
                </h4>
              </div>
              <div id="collapse-12" class="panel-collapse collapse in">
                <div class="panel-body">
                  Nach der Aktion "Versandpapiere erstellen" erhalten Sie eine Übersicht über alle relevanten Informationen der Bestellung. Im oberen Bereich der Seite finden Sie die Rechnungs- und die Lieferadresse des Kunden.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-14" data-parent="#accordion-test-2" data-toggle="collapse">
                    Gibt es einen Unterschied zwischen der Lieferadresse und der Rechnungsadresse?
                  </a>
                </h4>
              </div>
              <div id="collapse-14" class="panel-collapse collapse in">
                <div class="panel-body">
                  Rechnungs- und Lieferadresse können Sie nach der Aktion "Versandpapiere erstellen" den Detailinformationen der Bestellung entnehmen. Der Kunde hat innerhalb des Bestellprozesses auf jeder Plattform die Möglichkeit, eine separate Rechnungs- und Lieferadresse zu hinterlegen.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-15" data-parent="#accordion-test-2" data-toggle="collapse">Wie versende ich meine Pakete?</a>
                </h4>
              </div>
              <div id="collapse-15" class="panel-collapse collapse in">
                <div class="panel-body">
                  Die Ware muss in einer unifarbenen, neuen Versandverpackung versendet werden und das Paket mit dem einheitlichen schuhe.de-Packband verschlossen werden. Das schuhe.de Packband kann über die Firma Roper zu ANWR-Sonderkonditionen bezogen werden. Nur so kann die jeweilige Plattform seinen hohen Qualitätsansprüchen gerecht werden, um den Endkunden den Standard zu bieten, den er von anderen Anbietern gewöhnt ist.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-19" data-parent="#accordion-test-2" data-toggle="collapse">Wie wird eine Retoure abgewickelt?</a>
                </h4>
              </div>
              <div id="collapse-19" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sollten Sie eine Retoure erhalten, müssen Sie die Retoure <strong>innerhalb eines Werktages</strong> auf Qualibet melden. Wählen Sie hierzu die entsprechende Bestellung im Bestell-Bereich aus. Klicken Sie in der Bestellung bei dem zu retournierenden Artikel <strong>einzeln</strong> auf den Button "Optionen" und wählen die Aktion "Retoure" aus. Bitte prüfen Sie vor dieser Aktion sorgfältig ob Sie diesen Artikel tatsächlich retournieren möchten, da im Anschluss keine Veränderung der Aktion mehr möglich ist. Mit dem Retournier-Vorgang wird automatisch eine entsprechende Information per E- Mail an den Kunden und/oder den Marktplatz versendet. Die Rückerstattung erfolgt automatisiert über schuhe.de oder den entsprechenden Marktplatz und kann nicht mehr rückgängig gemacht werden.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-20" data-parent="#accordion-test-2" data-toggle="collapse">Wer übernimmt die Retourenkosten?</a>
                </h4>
              </div>
              <div id="collapse-20" class="panel-collapse collapse in">
                <div class="panel-body">
                  Die Kosten der Versendung der Retouren trägt der Händler. Siehe schuhe.de AGB‘s "Versandrichtlinien für Händler".
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-21" data-parent="#accordion-test-2" data-toggle="collapse">Ich habe die falsche Ware zurückerhalten. Was muss ich in diesem Fall tun?</a>
                </h4>
              </div>
              <div id="collapse-21" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sollte ein Kunde versehentlich die falsche Ware an Sie zurückgesendet haben, so nehmen Sie bitte Kontakt per E-Mail mit unserer entsprechenden Service-Abteilung (<a href="mailto:service@schuhe.de"><strong>service@schuhe.de</strong></a>, <a href="mailto:zalando@schuhe.de"><strong>zalando@schuhe.de</strong></a>, <a href="mailto:ebay@schuhe.de"><strong>ebay@schuhe.de</strong></a>) auf. Geben Sie dafür bitte im Betreff Ihrer E-Mail die entsprechende Bestellnummer an, fügen Ihrer E-Mail ein Bild des zurückgesendeten Artikels, ein Bild der Artikelbezeichnung auf dem Karton sowie einer Beschreibung des Falles an. Wir werden den Fall schnellstmöglich bearbeiten und Ihnen eine Rückmeldung zur weiteren Vorgehensweise geben.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-22" data-parent="#accordion-test-2" data-toggle="collapse">Ich habe getragene Ware zurückerhalten. Was muss ich in diesem Fall tun?</a>
                </h4>
              </div>
              <div id="collapse-22" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sollten Sie einen getragenen Artikel zurückerhalten haben, so nehmen Sie bitte Kontakt per E-Mail mit unserer entsprechenden Service-Abteilung (<a href="mailto:service@schuhe.de"><strong>service@schuhe.de</strong></a>, <a href="mailto:zalando@schuhe.de"><strong>zalando@schuhe.de</strong></a>, <a href="mailto:ebay@schuhe.de"><strong>ebay@schuhe.de</strong></a>) auf. Geben Sie dafür bitte im Betreff Ihrer E-Mail die entsprechende Bestellnummer an, fügen Ihrer E-Mail aussagekräftige Bilder des zurückgesendeten Artikels sowie einer Beschreibung des Falles an. Wir werden den Fall schnellstmöglich bearbeiten und Ihnen eine Rückmeldung zur weiteren Vorgehensweise geben.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-30" data-parent="#accordion-test-2" data-toggle="collapse">Wie wird die Verkaufsprovision verrechnet?</a>
                </h4>
              </div>
              <div id="collapse-30" class="panel-collapse collapse in">
                <div class="panel-body">
                  Die Verkaufsprovision wird innerhalb der Abrechnungsgutschrift als Rabatt abgezogen. Schuhe.de kauft Ihnen die bestellten Artikel und Versandkosten ab.                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-31" data-parent="#accordion-test-2" data-toggle="collapse">Wie und mit welcher Frist kündige ich meinen schuhe.de Nutzungsvertag?</a>
                </h4>
              </div>
              <div id="collapse-31" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sie kündigen den schuhe.de Nutzungsvertrag mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax oder E-Mail) unter Einhaltung einer vierwöchigen Kündigungsfrist zum Monatsende. Um das Widerrufsrecht auszuüben, senden Sie Ihre eindeutige Erklärung bitte an: ANWR-Media GmbH, Nord-West-Ring-Straße 11, DE-63533 Mainhausen, Tel. + 49 (0) 6182 / 928 -2274, Fax: + 49 (0) 6182 / 928 – 82274, E-Mail: <a href="mailto:service@schuhe.de"><strong>service@schuhe.de</strong></a>.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-32" data-parent="#accordion-test-2" data-toggle="collapse">Ich möchte die Verkaufsfunktion auf einem Marktplatz abschalten. Was muss ich in diesem Fall tun?</a>
                </h4>
              </div>
              <div id="collapse-32" class="panel-collapse collapse in">
                <div class="panel-body">
                  Bitte setzen Sie sich mit unserer Service-Abteilung in Verbindung, wenn Sie die Verkaufsfunktion auf einem Marktplatz abschalten möchten. Bitte beachten Sie, dass eine Reaktivierung in der Regel nach frühestens 14 Tagen möglich. Alle noch offenen Bestellungen sind abschließend zu bearbeiten.</div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-34" data-parent="#accordion-test-2" data-toggle="collapse">
                    Ich möchte meine Bankverbindung ändern. Wird diese automatisch über die DZB verändert?
                  </a>
                </h4>
              </div>
              <div id="collapse-34" class="panel-collapse collapse in">
                <div class="panel-body">
                  Die Bankverbindung für schuhe.de wird nicht automatisch durch die DZB geändert. Bitte beantragen Sie daher ein neues SEPA-Mandat bei schuhe.de und lassen uns dieses im Original per Post zukommen, damit wir die Bankverbindung ändern können. Bitte beachten Sie, dass dieser Vorgang einige Tage in Anspruch nehmen kann.
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="#collapse-35" data-parent="#accordion-test-2" data-toggle="collapse">In welcher Zeit erreiche ich einen Ansprechpartner bei schuhe.de?</a>
                </h4>
              </div>
              <div id="collapse-35" class="panel-collapse collapse in">
                <div class="panel-body">
                  Sie erreichen unsere Service-Abteilung von schuhe.de telefonisch von Mo. - Fr. von 09:00 bis 17:00 Uhr unter der Telefonnummer 06182-928 2274. Alternativ erreichen Sie unsere entsprechenden Service-Abteilungen per E-Mail unter <a href="mailto:service@schuhe.de"><strong>service@schuhe.de</strong></a>, <a href="mailto:zalando@schuhe.de"><strong>zalando@schuhe.de</strong></a>, <a href="mailto:ebay@schuhe.de"><strong>ebay@schuhe.de</strong></a>.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Faq',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
    this.$nextTick(function () {
    })
  }
}
</script>
<style scoped>
  .panel {
    background-color: #282a31 !important;
  }
  .panel-heading {
    background-color: #212228 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Faq.vue